
<template>
  <div>
    <!-- 一级路由出口 -->
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
export default {

}

  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?8c556b5f228e9a9678dc164370a65e3e";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

</script>

<style>

</style>